import { computed } from "vue";
import { useRoute } from "vue-router";
import { useAuthStore } from "@/store/auth";

export function useShellVisibility() {
  const route = useRoute();
  const authStore = useAuthStore();

  const hasApplicationHeader = computed(
    () => route.meta.shell === "application",
  );
  const hasContentFrame = computed(
    () => route.meta.shell !== undefined && route.meta.shell !== "none",
  );
  const isReader = computed(() => route.meta.shell === "reader");
  const shouldShowNavbar = computed(
    () =>
      route.meta.navbar === "persistent" ||
      (route.meta.navbar === "authenticated" && authStore.isAuthed),
  );
  const shouldShowSidepanel = computed(
    () => authStore.isAuthed && route.meta.sidepanel === "global",
  );

  return {
    hasApplicationHeader,
    hasContentFrame,
    isReader,
    shouldShowNavbar,
    shouldShowSidepanel,
  };
}
